// import {clientConfig} from '@modifi/client-config'

const captchaUrlHardcodedForTesting =
  'https://recaptcha.net/recaptcha/api.js?render=6Lcqnl0UAAAAAMz8CErH5JiClMhJzWQTLjDVNOky'

const loadRecaptcha = () =>
  new Promise((resolve, reject) => {
    // const captchaApiUrl = clientConfig.get('captcha_api_url')
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.onload = resolve
    s.onerror = () => {
      const error = new Error(`failed to load recaptcha: ${captchaUrlHardcodedForTesting}`)
      reject(error)
    }
    // s.src = process.env.REACT_APP_CAPTCHA_API_URL
    s.src = captchaUrlHardcodedForTesting
    document.body.appendChild(s)
  })

export default loadRecaptcha
